<template>
  <div class="recommend" ref="sport" id="sport">
    <div class="recommend-title">
      <h2>商務背包 - Bag</h2>
      <h3>為您選購 newred 產品。為您的旅途中添加好夥伴！</h3>
    </div>
    <ul class="rec-ul">
        <li v-for="(pic, index) in picAll" :key="index" class="rec-li">
          <div class="demo-image__preview">
            <el-image
              style="width: 100%;"
              :src="pic.picUrl"
              :preview-src-list="pic.srcList"
              lazy
              alt="product"
            >
            <div slot="placeholder" class="image-slot">
              <!-- 加载中<span class="dot">...</span> -->
              <i class="el-icon-loading"></i>
            </div>
            </el-image>
            <div class="rec_text">
              <div class="rec_only">
                <!-- <p class="rec_color" v-bind:style="{backgroundColor: pic.myColor1}"></p>
                <p class="rec_color" v-bind:style="{backgroundColor: pic.myColor2}"></p>&emsp; -->
                <p>{{pic.text1}} | {{pic.text2}}</p>
              </div>
              <h1>{{pic.name}}</h1>
              <h2>型號: {{pic.number}}</h2>
            </div>
            <div class="rec_click">
              <p>請點擊圖片</p>
              <i class="el-icon-picture-outline rec-i"></i>
            </div>
          </div>
        </li>
    </ul>
  </div>
</template>

<script>
  import {productItemsBag} from './config';

  export default {
    name: 'Recommend',
    data() {
      return {
        picAll: productItemsBag
      };
    },
    // 獲取遠程數據
    created() {
      // this.picAll = productItems;
    }

  };

</script>
<style lang='scss' scoped>
  @import "~assets/scss/product";
</style>



// WEBPACK FOOTER //
// src/pages/Home/sport.vue